const Processor = () => {
  return <div className="process"></div>;
};

export default Processor;
